<template>
  <div class="teaser-list-item">
    <div class="teaser">
      <div class="teaser-image cell">
        <generic-link :href="path">
          <div class="image-container aspect-ratio-16by9 effect-image-scale">
            <div
              :style="{ backgroundImage: 'url(\'' + image + '\')' }"
              class="image-background"
            />
          </div>
        </generic-link>
      </div>

      <div class="teaser-content cell">
        <div
          v-if="category"
          class="article-teaser-content-element article-teaser-category"
        >
          <span class="article-category-link">
            {{ category }}
          </span>
        </div>

        <generic-link :href="path">
          <div class="title">
            <h3>{{ title }}</h3>
          </div>
        </generic-link>
        <div
          class="description"
        >
          {{ content }}
        </div>
        <div class="date">
          <font-awesome-icon icon="clock" />
          <span class="published-date">
            {{ created }}
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {pageMixin} from '../node-front-news-common'

import { library } from '@fortawesome/fontawesome-svg-core'
import {
  faClock
} from '@fortawesome/free-solid-svg-icons'

library.add(
  faClock
)

export default {
  mixins: [
    pageMixin
  ],
  props: {
    item: {
      type: Object,
      required: true,
      default: function() { return {} }
    },
    truncateText: {
      type: Number,
      required: false,
      default: 150
    }
  }
}
</script>

<style lang="scss" scoped>
@import "~@scss/custom.scss";

.article-teaser-image .img-reflow-overlay {
  max-width: 100%;
  width: 100%;
  padding-bottom: 56.25%;
  height: 0;
  height: 0;
  background: #5c7274;
}

.teaser-list-item a.teaser-click-link {
  position: absolute;
  margin: auto;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  text-indent: -99em;
  white-space: nowrap;
  overflow: hidden;
  z-index: 0;
}
.image-container {
  overflow:hidden;
  display:flex;
  position:relative;
  -webkit-backface-visibility: hidden;
    @if $enable-rounded {
    border-radius: $border-radius-sm;
  }
}
.aspect-ratio-16by9 {
  @include responsive-ratio(16,9);
}
.image-background{
  height: 100%;
  width: 100%;
  position: absolute;
  background-size: cover;
  background-position: 50%;
}
//teaser image position
.teaser-image {
  position: relative;
  overflow: hidden;
  width: 100%;
  z-index: 2;

.image-container {
  @if $enable-rounded {
    overflow: hidden;
    position: relative;
    border-radius: $border-radius-sm;
  }
}
}

.teaser {
  .description {
    margin-bottom:1em;
  }
  .date {
    display:flex;
    align-items: center;
    svg {
      color:var(--main-border-color);
      margin-right:.5em;
    }
  }
  .title {
    h3 {
      font-size:1.6rem;
    }
  }
}

</style>
